<template>
  <el-card shadow="never" :body-style="{padding: '5px'}">
    <el-row>
      <el-col :xs="6" :sm="6" :md="3" :xl="3">
        <router-link to="/help" class="HotText">
          <div class="HotBtn">
            <svg-icon icon-class="newurl" style="fill:#f39"></svg-icon>
            <div class="label">最新地址</div>
          </div>
        </router-link>
      </el-col>
      <el-col :xs="6" :sm="6" :md="3" :xl="3">
        <router-link to="/lists" class="HotText">
          <div class="HotBtn">
            <svg-icon icon-class="new" style="fill:#f39"></svg-icon>
            <div class="label">最新信息</div>
          </div>
        </router-link>
      </el-col>
      <el-col :xs="6" :sm="6" :md="3" :xl="3">
        <router-link to="/publish" class="HotText">
          <div class="HotBtn">
            <svg-icon icon-class="publish" style="fill:#f39"></svg-icon>
            <div class="label">发布信息</div>
          </div>
        </router-link>
      </el-col>
      <el-col :xs="6" :sm="6" :md="3" :xl="3">
        <router-link to="/upgrade" class="HotText">
          <div class="HotBtn">
            <svg-icon icon-class="vip" style="fill:#f39"></svg-icon>
            <div class="label">升级VIP</div>
          </div>
        </router-link>
      </el-col>
      <el-col :xs="6" :sm="6" :md="3" :xl="3">
        <router-link to="/merchant" class="HotText">
          <div class="HotBtn">
            <svg-icon icon-class="speaker" style="fill:#f39"></svg-icon>
            <div class="label">商家频道</div>
          </div>
        </router-link>
      </el-col>
      <el-col :xs="6" :sm="6" :md="3" :xl="3">
        <router-link to="/help" class="HotText">
          <div class="HotBtn">
            <svg-icon icon-class="message" style="fill:#f39"></svg-icon>
            <div class="label">积分规则</div>
          </div>
        </router-link>
      </el-col>
      <el-col v-for="item of icon_ad" :key="item.title" :xs="6" :sm="6" :md="3" :xl="3">
        <a :href="item.url" class="HotText" target="view_window">
          <div class="HotBtn">
            <svg-icon :icon-class="item.svg" :style="item.color"></svg-icon>
            <div class="label">{{item.title}}</div>
          </div>
        </a>
      </el-col>
      <!--<el-col :xs="6" :sm="6" :md="3" :xl="3">-->
        <!--<router-link to="/promote" class="HotText">-->
          <!--<div class="HotBtn">-->
            <!--<svg-icon icon-class="tui" style="fill:#8338ec"></svg-icon>-->
            <!--<div class="label">推广送会员</div>-->
          <!--</div>-->
        <!--</router-link>-->
      <!--</el-col>-->

    </el-row>
  </el-card>
</template>

<script>
export default {
  name: 'ad',
  data () {
    return {
      icon_ad: ''
    }
  },
  created () {
    this.ads()
  },
  methods: {
    ads () {
      this.icon_ad = JSON.parse(localStorage.getItem('ad')).icon
      this.info_ad = JSON.parse(localStorage.getItem('ad')).info
    }
  }
  // mounted () {
  //   request({
  //     url: '/api/Ads',
  //     method: 'post'
  //   }).then(res => {
  //     this.ad = res.data.icon
  //   }).catch(err => {
  //     console.log(err)
  //   })
  // }
}
</script>

<style scoped>

  a {
    color: #42b983;
  }
  .HotBtn{
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .svg-icon {
    width: 2.3em;
    height: 2.3em;
    vertical-align: -0.15em;
    fill: currentColor;
  }
  .HotText{
    color: black;
    text-decoration:none;
    font-size: 14px;
  }
  a:hover{
    text-decoration:underline;
  }
  .label{
    margin-top: 4px;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/widget/ad.vue